import { createSlice } from '@reduxjs/toolkit';
import { UserSchema } from '../types/userTypes';

const initialState: UserSchema = {
    user: {
        avatar: '',
        avatar_name: '',
        birthday: '',
        current_scene: {},
        email: '',
        email_verified_at: '',
        level: 1,
        name: '',
        region: '',
        sex: '',
        surname: '',
        phone: '',
    },
    plotOptions: '',
    // @ts-ignore
    cart: {
        sum: 0,
    },
    gameData: {
        game: {
            id: '',
            name: '',
            max_attempts: 0,
            level: 0,
        },
        profession: '',
        sum_score: 0,
        attempts_used: 0,
    },
    currentCart: null,
    isDropped: false,
};

export const UserSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        setUser: (state, { payload }) => {
            state.user = payload;
        },
        setPlotOptions: (state, { payload }) => {
            state.plotOptions = payload;
        },
        setCart: (state, { payload }) => {
            state.cart = payload;
        },
        setCartSum: (state, { payload }) => {
            state.cart.sum = payload;
        },
        setGameData: (state, { payload }) => {
            state.gameData = payload;
        },
        setPhoneNumber: (state, { payload }) => {
            state.user.phone = payload;
        },
        setRestartState: (state, { payload }) => {
            console.log(payload, 'userRestartState payload')
            state.isDropped = payload;
        },
        setCurrentInitCart: (state, { payload }) => {
            const currentCart = {};
            payload.map(({ products }: any) => {
                products.map(({ name, in_cart }: any) => {
                    //@ts-ignore
                    currentCart[name] = in_cart;
                })
            });
            state.currentCart = currentCart;
        },
        addGoodToCart: (state, { payload }) => {
            state.currentCart[payload.name] = payload.value;
        }
    },
});

export const { actions: userActions } = UserSlice;
export const { reducer: userReducer } = UserSlice;
